import PropTypes from 'prop-types';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import { css } from '@emotion/core';
import CorgixButton from '@veeva/corgix/button';
import { isMobile } from '../services/DeviceInformation';
import mobileContentWidthCSS from '../constants/mobileContentWidthCSS';

const propTypes = {
    /**
     * Automation marker
     */
    [`data-target`]: PropTypes.string,
    children: PropTypes.string,
    // we should not use className for writing css in css file.
    // This className is here so we can use emotions css that it will get convert to classname by emotion
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    type: PropTypes.string,
    variant: PropTypes.oneOf(['primary', 'secondary', 'ghost']),
};

const Button = ({
    children,
    disabled,
    onClick,
    variant = 'primary',
    className,
    type = 'button',
    [`data-target`]: dataTarget,
}) => {
    const buttonCSS = [
        css`
            width: 35rem;
        `,
        isMobile() &&
            css`
                ${mobileContentWidthCSS};
            `,
    ];

    return (
        <EmotionThemeProvider
            theme={{
                buttonBorderRadius: '8px',
                buttonHeight: '3.333rem',
                buttonFontSize: '1.333rem',
                buttonPrimaryBackgroundColorDisabled: '#f8f8f8',
                buttonPrimaryTextColorDisabled: '#dadada',
                buttonPrimaryBorderColorDisabled: '#dadada',
            }}
        >
            <CorgixButton
                className={className}
                css={buttonCSS}
                disabled={disabled}
                onClick={onClick}
                variant={variant}
                type={type}
                data-target={dataTarget}
            >
                {children ?? ' '}
            </CorgixButton>
        </EmotionThemeProvider>
    );
};

Button.propTypes = propTypes;

export default Button;
